import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import OrderSettingsPageStoreContext from "../context";
import {
    Button,
    FlexRowSpaceBetween,
    Paper,
    Typography
} from "../../../../../common/components/libs";
import { useStores } from "../../../../../hooks";
import useAliases from "../../../../../hooks/useAliases";
import { Link } from "@material-ui/core";
import { Plus as AddIcon } from "react-feather";
import { MenuFormType } from "../../../store/generalMenuStore/forms";
import { useTranslation} from "react-i18next";

const AliasesBlock = () => {
    const {t} = useTranslation(["general", "menu"]);
    const store = useContext(OrderSettingsPageStoreContext);
    const { generalMenuStore, authStore } = useStores()
    const [aliases, setMenuId, setForceReload] = useAliases(authStore.currentUser.organizationData.organizationBranchId);

    useEffect(() => {
        if (store.current) {
            setMenuId(store.current.id)
        } else {
            setMenuId(undefined);
        }
    }, [store.current?.id])

    let host;

    if (window.location.hostname === "my.restify.one") host = `https://menu.restify.one`;
    else host = `https://dev-menu.restify.one`;

    return <>
        <Typography variant={"h3"} mt={20}>
            {t("menu:orderSettingsPage.menuLink")} <span role="img">🚀</span>
        </Typography>
        <Typography variant={"body2"} mb={2} color={'textSecondary'}>
            {t("menu:orderSettingsPage.insertMenuLinkToSocialNetworks")}
        </Typography>

        {
            aliases.map(item => {
                return <Paper p={5} mt={2}>
                    <FlexRowSpaceBetween style={{ alignItems: "center" }}>
                        <Typography variant="h6"
                                    color={'primary'}>
                            <Link key={item.alias} href={`${host}/${item.alias}`}>
                                {host}/{item.alias}
                            </Link>
                        </Typography>
                    </FlexRowSpaceBetween>
                </Paper>
            })
        }


        <Button
            color="primary"
            variant={'contained'}
            fullWidth
            mt={2}
            onClick={() => {
                generalMenuStore.forms.setMenuIdForEditAlias(store.current.id, () =>
                    setForceReload(true)
                );
                generalMenuStore.forms.showPopupForm(MenuFormType.editAlias);
            }}
        >
            <AddIcon/>
            {t("menu:orderSettingsPage.insertMenuLink")}
        </Button>
    </>

}


export default observer(AliasesBlock);
